<template>
  <div class="date-container" :class="{error:error}">
    <Datepicker
      class="input-month"
      v-model="date"
      :format="dateformat"
      locale="ja"
      :clearable="clearable"
      :disabled="disabled"
      monthPicker
    />
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export interface MonthPickerModelValue {
  year: number,
  month: number
}

export default defineComponent({
  setup(props, context) {
    const date = computed({
      get() {
        return props.modelValue
      },
      set(val: MonthPickerModelValue) {
        context.emit('update:modelValue', val);
      }
    })
    const dateformat = ref('yyyy年MM月')
    return {
      date,
      dateformat
    }
  },
  props: ['modelValue', 'error', 'clearable', 'disabled'],
  components: {
    Datepicker
  }
})
</script>
